import type { ReactNode } from "react";
import { Navigate } from "react-router";
import { useFlags } from "launchdarkly-react-client-sdk";

import { LearnAppRoutes } from "sj-ui-toolkit/src/constants/routes";

/**
 * The nav link and search bar are hidden by the same `turnOffCatalog` flag; this
 * closes the direct-URL route so the kill switch can't be bypassed by bookmark.
 */
const RequireCatalogEnabled = ({ children }: { children: ReactNode }) => {
  const { turnOffCatalog } = useFlags();

  if (turnOffCatalog) {
    return <Navigate to={LearnAppRoutes.route} replace />;
  }

  return <>{children}</>;
};

export default RequireCatalogEnabled;
